import { z } from 'zod';

export const FeedbackTypeSchema = z.enum(['Positivo', 'Negativo', 'Neutro']);

export const FeedbackEntrySchema = z.object({
    id: z.string(),
    date: z.string(),
    type: FeedbackTypeSchema,
    annotation: z.string(),
    responsibleCollaboratorId: z.string().nullable().optional(),
    responsibleClientName: z.string().optional(),
});

export type FeedbackType = z.infer<typeof FeedbackTypeSchema>;
export type FeedbackEntry = z.infer<typeof FeedbackEntrySchema>; 